const KOREAN_NAME = {
  BK_K_NPAY: '케이뱅크엔페이연합통장',
  // 케이뱅크 X Npay 이벤트통장
  BK_SHINHAN_NPAY: '신한엔페이연합통장',
  // 신한은행 X Npay 이벤트통장
  CD_NAVER_PAY: '네이버페이',
  // 네이버페이
  CD_KAKAO_PAY: '카카오페이',
  // 카카오페이
  IV_NAVER_MIRAE: '미래에셋네이버통장',
  // 미래에셋 네이버통장
  CD_MASTER_CARD: 'master',
  // 마스터카드
  CD_VISA: 'visa' // 비자
};
var KOREAN_NAME$1 = KOREAN_NAME;

export { KOREAN_NAME$1 as default };
